<template>
  <div>
    <v-card>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="addBadge()"> Add new badge </v-btn>
      </v-card-actions>
      <v-row v-if="$apollo.loading" align="center" justify="center">
        <v-col lg="6" md="8" sm="12">
          <v-skeleton-loader type="card, card, card" />
        </v-col>
      </v-row>
      <v-row v-else align="center" justify="center">
        <v-col lg="6" md="8" sm="12">
          <v-autocomplete
            v-model="search"
            multiple
            :items="allBadges"
            chips
            deletable-chips
            hide-selected
            :item-value="(val) => val.id"
            :item-text="(val) => val.title"
            label="Type to find a badge"
            clearable
            background-color="navy"
            dark
            rounded
            class="pt-0"
          />
          <v-card-title class="secondary--text font-weight-bold font-24">
            To be awarded manually
          </v-card-title>
          <v-card v-if="badges && badges.length == 0">
            <v-card-subtitle class="text-center"> No {{ namedType }} badges to display </v-card-subtitle>
          </v-card>
          <badge-card
            v-for="badge in badges"
            :key="badge.id"
            :badge="badge"
            :type="namedType"
            @edit="editBadge(badge)"
          />
        </v-col>
      </v-row>
      <v-card-actions v-if="badges && badges.length > 4">
        <v-spacer />
        <v-btn @click="addBadge()"> Add new badge </v-btn>
      </v-card-actions>
    </v-card>

    <badge-dialog :badgeModal="badgeModal" :type="namedType" @close="badgeModal.show = false" />
  </div>
</template>

<script>
import BadgeListMixin from "./mixins/BadgeListMixin";

export default {
  name: "CustomBadges",
  mixins: [BadgeListMixin],
  data() {
    return {
      type: "challenge",
      namedType: "custom",
    };
  },
  methods: {
    addBadge() {
      let form = {
        id: null,
        title: "",
        description: "",
        image: null,
        imageChanged: false,
        enabled: false,
        visible: false,
        sendgridTemplateId: null,
      };

      this.badgeModal.form = form;
      this.badgeModal.show = true;
    },
    editBadge(badge) {
      let form = {
        id: badge.id,
        title: badge.title,
        description: badge.description,
        image: badge.iconLink,
        imageChanged: false,
        enabled: false,
        visible: false,
        sendgridTemplateId: badge.sendgridTemplateId,
      };

      this.badgeModal.form = form;
      this.badgeModal.show = true;
    },
  },
  computed: {
    allBadges() {
      return this.adminBadges?.filter((badge) => {
        let qualifiers = JSON.parse(badge.functionValues)?.qualifiers;
        return !(qualifiers && qualifiers.length > 0);
      });
    },
    badges() {
      return this.allBadges?.filter((badge) => this.search.length == 0 || this.search.includes(badge.id));
    },
  },
};
</script>

<style scoped>
.font-24 {
  font-size: 24px;
}
</style>
